import { Injectable, Injector } from '@angular/core';
import { EFormView, EFormViewFactory, EFormViewRegistry, EFormViewSection, EFormViewSectionFactory } from '../../model/eform/eform-api.model';
import { ComponentType, ComponentPortal } from '@angular/cdk/portal';
import { Observable, of } from 'rxjs';
import { DynFormSection } from '../../model/dyn-form/dyn-form-section.model';
import { ProcedureInstanceBase } from '../../model/procedure-instance/procedure-instance.model';
import { EFormViewDefaultComponent } from '../../components/eform-view/e-form-view-default/e-form-view-default.component';
import { EFormViewAttachedComponent } from '../../components/eform-view/e-form-view-attached/e-form-view-attached.component';
import { DynamicViewSectionComponent } from '../../components/eform-view/dynamic-view-section/dynamic-view-section.component';

@Injectable({
	providedIn: 'root'
})
export class EFormViewFactoryService implements EFormViewSectionFactory, EFormViewFactory {

	forms: Map<string, ComponentType<EFormView>> = new Map()
	sections: Map<string, ComponentType<EFormViewSection>> = new Map()

	constructor() {
		this.forms.set("default", EFormViewDefaultComponent)
		this.forms.set("form-attached", EFormViewAttachedComponent)
		this.sections.set("default", DynamicViewSectionComponent)
	}

	loadSection(section: DynFormSection): ComponentType<EFormViewSection> {
		const key = "" + section.type

		let component: ComponentType<EFormViewSection> | undefined = this.sections.get(key)
		if (component != null) {
			return component
		}
		return <ComponentType<EFormViewSection>>this.sections.get("default")
	}

	newEFormViewSection(section: DynFormSection, procedureInstance: ProcedureInstanceBase, isAllSectionsLoaded: (sectionId: number) => void): Observable<ComponentPortal<EFormViewSection>> {
		let injector = Injector.create({ providers: [{ provide: "CONTAINER_DATA", useValue: { procedureInstance, section, isAllSectionsLoaded } }] })
		let portal: ComponentPortal<EFormViewSection> = new ComponentPortal(this.loadSection(section), null, injector)
		return of(portal)
	}

	loadEFormView(serviceCode: string, procedureCode: string): ComponentType<EFormView> {
		const key = serviceCode + "-" + procedureCode

		let component: ComponentType<EFormView> | undefined = this.forms.get(key)
		if (component != null) {
			return component
		}
		return <ComponentType<EFormView>>this.forms.get("default")
	}

	newEFormView(registry: EFormViewRegistry, procedureInstance: ProcedureInstanceBase, serviceCode: string, procedureCode: string): Observable<ComponentPortal<EFormView>> {
		let injector = Injector.create({ providers: [{ provide: "CONTAINER_DATA", useValue: { registry, procedureInstance } }] })
		if (this.isFromE2(procedureInstance)) {
			let portal: ComponentPortal<EFormView> = new ComponentPortal(this.loadEFormView("form", "attached"), null, injector)
			return of(portal)
		}
		let portal: ComponentPortal<EFormView> = new ComponentPortal(this.loadEFormView(serviceCode, procedureCode), null, injector)
		return of(portal)
	}

	private isFromE2(procedureInstance: ProcedureInstanceBase) {
		return procedureInstance.procedureInstanceCode < 100000000;
	}
}
